import ApplicationRouting from './components/ApplicationRouting.jsx'

import bootstrap from '../node_modules/bootstrap-less/bootstrap/bootstrap.less';
import styles from './styles/styles.less';

import React from 'react';
import ReactDOM from 'react-dom/client'; // ✅ Use 'react-dom/client'

const root = ReactDOM.createRoot(document.getElementById('root')); // ✅ Correct method
root.render(<ApplicationRouting />);